import { format } from "date-fns";
import { formatDate } from "../../../../utils";
import { value } from "../../../../helpers";

export const REGIMES = [
  {
    value: "CAIXA",
    label: "Caixa",
    descricao: "Regime de Caixa — pela liquidação (data do pagamento)",
  },
  {
    value: "COMPETENCIA",
    label: "Competência",
    descricao: "Regime de Competência — pela data de competência do título",
  },
];

export const PERIODOS = [
  { label: "Diário", value: "DIA" },
  { label: "Semanal", value: "SEMANA" },
  { label: "Mensal", value: "MES" },
];

export const PERIODO_PRESETS = [
  { label: "Este mês", mesAtual: true },
  { label: "3 meses", meses: 3 },
  { label: "6 meses", meses: 6 },
  { label: "12 meses", meses: 12 },
  { label: "Este ano", anoAtual: true },
];

export function periodoInicial() {
  const hoje = new Date();
  return {
    dataInicio: formatDate.toSend(
      new Date(hoje.getFullYear(), hoje.getMonth(), 1),
    ),
    dataFim: formatDate.toSend(hoje),
  };
}

export const filtrosIniciais = {
  ...periodoInicial(),
  centroCusto: null,
  planoFinanceiro: null,
  empresas: [],
  agrupamento: "DIA",
  regime: "CAIXA",
};

export function intervaloPreset(preset) {
  const hoje = new Date();
  const dataFim = formatDate.toSend(hoje);
  if (preset.anoAtual) {
    return {
      dataInicio: formatDate.toSend(new Date(hoje.getFullYear(), 0, 1)),
      dataFim,
    };
  }
  if (preset.mesAtual) {
    return {
      dataInicio: formatDate.toSend(
        new Date(hoje.getFullYear(), hoje.getMonth(), 1),
      ),
      dataFim,
    };
  }
  return {
    dataInicio: formatDate.toSend(
      new Date(hoje.getFullYear(), hoje.getMonth() - (preset.meses - 1), 1),
    ),
    dataFim,
  };
}

export function formatarDataChip(dataStr) {
  if (!dataStr) return "";
  return format(value.date(dataStr), "dd/MM/yyyy");
}

export function labelPlanoFinanceiro(plano) {
  if (!plano) return "";
  return plano.codigo ? `${plano.codigo} - ${plano.descricao}` : plano.descricao;
}
